import React, { useEffect, useState } from "react";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";

const DEBOUNCE_DELAY = 1000;

const CustomAutocompleteField = ({
  margin,
  disabled,
  launch,
  label,
  setValue,
  value,
  noOptionsText,
  labelField,
  required,
}) => {
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [debouncedInputValue, setDebouncedInputValue] = useState("");

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedInputValue(inputValue);
    }, DEBOUNCE_DELAY);

    return () => {
      clearTimeout(handler); // Clear timeout on cleanup
    };
  }, [inputValue]);

  useEffect(() => {
    if (debouncedInputValue === "") {
      setOptions(value ? [value] : []);
      return undefined;
    }

    let active = true;
    launch(debouncedInputValue, (results) => {
      if (!active) {
        return;
      }
      let newOptions = [];
      if (results) {
        newOptions = results;
        if (value) {
          newOptions = [
            value,
            ...results.filter(
              (result) => result[labelField] !== value[labelField]
            ),
          ];
        }
      } else if (value) {
        newOptions = [value];
      }
      setOptions(newOptions);
    });
    return () => {
      active = false;
    };
  }, [value, debouncedInputValue, launch, labelField]);

  return (
    <FormControl fullWidth margin={margin} disabled={disabled}>
      <Autocomplete
        getOptionLabel={(option) =>
          typeof option === "string" ? option : option[labelField]
        }
        filterOptions={(x) => x}
        options={options}
        autoComplete
        includeInputInList
        filterSelectedOptions
        value={value}
        noOptionsText={noOptionsText}
        onChange={(event, newValue) => {
          setOptions(newValue ? [newValue, ...options] : options);
          setValue(newValue);
        }}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="filled"
            required={required}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {false ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </FormControl>
  );
};

export default CustomAutocompleteField;
